export const common = {
  type: {
    messaging: {
      title: 'Messages',
      sms: 'SMS',
      hlr: 'HLR'
    },
    voice: {
      title: 'Voice communication',
      inc_voice: 'Incoming calls',
      out_voice: 'Outgoing calls',
      pbx_inc_voice: 'PBX Incoming calls',
      pbx_out_voice: 'PBX Outgoing calls',
      autocaller_inc_voice: 'Autoinformer Incoming calls',
      autocaller_out_voice: 'Autoinformer Outgoing calls',
      predictive_out_voice: 'Predictive Dialer Outgoing calls',
      predictive_inc_voice: 'Predictive Dialer Incoming calls',
      amo_out_voice: 'Widget CRM Outgoing calls',
      amo_inc_voice: 'Widget CRM Incoming calls',
      kommo_inc_voice: 'Incoming voice widget Kommo CRM',
      kommo_out_voice: 'Outgoing voice widget Kommo CRM'
    },
    number_verification: {
      title: 'Verification of numbers',
      sms_number_verification: 'Verification by SMS',
      call_number_verification: 'Outgoing call verification',
      phone_number_verification: 'Incoming call verification',
      voice_number_verification: 'Incoming call verification with code dictation'
    }
  },

  info: {
    no_rates: 'No rates',
    billing_terms_tooltip:
      '<b>FT (FreeTime)</b> - this is the time in seconds from the start of the call, during which it is not charged.<br/><b>MC (Minimum Commitment)</b> – is the minimum initial billing interval. That is, the time after the end of the FT, for which the money will be debited, even if the call was shorter than this time.<br/><b>CI (Commitment Interval)</b> – is the main billing interval. That is, the interval for which the call will be charged after FT and MC. If CI=0, then the call will be charged according to MC until the very end.'
  },

  field: {
    name: 'Name',
    mcc: 'MCC',
    mnc: 'MNC',
    code: 'Code',
    country: 'Country',
    provider: 'Mobile service provider',
    price: 'Price',
    date_start: 'Valid from',
    date_end: 'Valid until',
    trunk: 'Trunk',
    billing_terms: 'Billing terms'
  }
};
